import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

interface mutateProps { communityId: string, data: FieldValues }

const mutateUpdateCommunityStatus = async ({ communityId, data }: mutateProps) => {
  return await axiosAuth.put(`${GET_COMMUNITIES}/${communityId}/status`,
    data
  );
};

const useUpdateCommunityStatusMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateCommunityStatus,
    ...queryParams,
  });

export default useUpdateCommunityStatusMutation;
